var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"-d-flex",attrs:{"id":"dashboard-total-orders-component"}},[_c('v-row',[_c('v-col',[_c('span',{staticClass:"grey--text text-h3"},[_vm._v("Total Orders")]),_c('apexchart',{attrs:{"type":"bar","height":"550","options":_vm.chartOptions,"series":_vm.series}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }